import { useAuthStore } from '@/store/auth';
import { holdsPermission, type Permission } from '@/api/permissions';

/**
 * `can` for a single/AND check, `canAny` for an OR check. `isPlatform` is not
 * a permission — it is the role's `is_platform` flag — but it lives here
 * because it answers the same question ("may I show this?").
 */
export function usePermissions() {
  const can = useAuthStore((s) => s.can);
  const canAny = useAuthStore((s) => s.canAny);
  const permissions = useAuthStore((s) => s.permissions);
  const isPlatform = useAuthStore((s) => s.isPlatform);
  return { can, canAny, permissions, isPlatform, has: (p: Permission) => holdsPermission(permissions, p) };
}
